<template>
  <div id="app">
    <sp-layout
      :title="title"
      :navigation="navigation"
      :links="links"
      :show-hamburguer-icon="isLogged"
      :show-left-menu="isLogged"
      :loading-left-menu="loadingLeftMenu"
      :cityName="managingUnit"
      :version="version"
      :accessName="logged.nome"
      :profile="profile"
      :flagUrl="flagUrl"
      hide-root-no-leaves
    >
      <router-view />
      <ChangePassword ref="changePassword" />
    </sp-layout>
  </div>
</template>
<script>
import { cityFlag } from 'sapitur-toolkit-vue';
import { healthService, userService } from '@/services';
import ChangePassword from '@/components/home/ChangePassword.vue';
import defautNavigation from '@/navigation';
import pkg from '../package.json';

export default {
  components: { ChangePassword },
  data() {
    return {
      title: 'Servidor Online',
      navigation: defautNavigation,
      version: pkg.version,
      config: {},
    };
  },
  mounted() {
    this.me();
    this.getConfig();
  },
  methods: {
    getConfig() {
      healthService.config().then((data) => {
        this.$store.commit('SET_CITY', { ...data, flag: cityFlag(data.id) });
      });
    },
    onChangePassword() {
      this.$refs.changePassword.show();
    },
    me() {
      userService.me();
    },
    onLogout() {
      this.$store.commit('LOGOUT');
      this.$router.push('/');
    },
  },
  computed: {
    managingUnit() {
      return this.$store.getters.getCity.unidadeGestora;
    },
    flagUrl() {
      return this.$store.getters.getCity.flag;
    },
    isLogged() {
      return this.$store.getters.isLogged;
    },
    logged() {
      return this.$store.getters.getLogged;
    },
    loadingLeftMenu() {
      return false;
    },
    links() {
      if (this.$route.meta.breadcrumb) return this.$route.meta.breadcrumb;
      return [];
    },
    profile() {
      if (!this.isLogged) return null;

      return {
        title: 'Perfil do Usuário',
        user: {
          name: this.logged.nome,
        },
        actions: [{ label: 'Alterar Senha', action: this.onChangePassword }],
        logout: {
          label: 'Logout',
          action: this.onLogout,
        },
      };
    },
  },
};
</script>
